import styled from 'styled-components';

import { GenericDiv } from 'commonStyles';

export const Container = styled(GenericDiv)`
  background: #f5f5f5;
  img {
    object-fit: contain;
  }
`;

export const DownloadSectionRightWrap = styled.div(
	({ theme: { down, breakpoints } }) => `

      ${down(breakpoints.md)} {
          width: 100%;
          margin-left: 0;
      }
      width: 60%;
      padding-top: 20px;
      margin-left: 40px;
			max_height: 533px;
    `
);

export const QrCodeText = styled.div`
  font-weight: 900;
  font-size: 22px;
  padding: 32px 0 16px 0;
`;

export const AppDownloadBtnWrapper = styled.div(
	({ theme: { down, breakpoints } }) => `

    display: inline-flex;
    align-items: flex-end;
    justify-content: flex-end;
    padding-bottom:16px;
    > div {
      &:first-child {
        margin-right: 20px;
      }
    }
    a {
      height: 50px;
      display: inline-block;
    }

      ${down(breakpoints.md)} {
        justify-content: flex-start;
      }
  
    `
);
